import { provisionEventsLinkGenerator } from './provision-events-link-generator';
import { Customer } from 'features/organizations/customers/models/customer-models';
import { Site } from 'features/organizations/sites/models/sites-models';
import { Asset } from 'features/organizations/assets/models/asset-models';
import { AssetSection } from 'features/organizations/asset-sections/models/asset-section-models';
import { FormatOptions } from '@metsooutotec/modes-react-components/dist/components/i18n/IntlProvider';

export const provisionEventsBreadcrumbsGenerator = (
    customer: Customer | undefined,
    site: Site | undefined,
    asset: Asset | undefined,
    assetSection: AssetSection | undefined,
    formatMessage: (id: string, options?: FormatOptions) => string
): { text: string; to: string }[] => {
    // to solve
    const breadcrumbs: { text: string; to: string }[] = [
        {
            text: formatMessage('customerList.title'),
            to: '/',
        },
        {
            text: formatMessage('provisionEvents.title'),
            to: provisionEventsLinkGenerator(),
        }
    ];

    if (customer) {
        breadcrumbs.push({
            text: customer.name,
            to: provisionEventsLinkGenerator(customer),
        });

        if (site) {
            breadcrumbs.push({
                text: site.name,
                to: provisionEventsLinkGenerator(customer, site),
            });

            if (asset) {
                breadcrumbs.push({
                    text: asset.name,
                    to: provisionEventsLinkGenerator(customer, site, asset),
                });

                if (assetSection) {
                    breadcrumbs.push({
                        text: assetSection.name,
                        to: provisionEventsLinkGenerator(customer, site, asset, assetSection),
                    });
                }
            }
        }
    }

    return breadcrumbs;
};